import React, { Component } from 'react';
// import PropTypes from 'prop-types';

class GlobalDeforestationFrontsContent extends Component {

  render() {
    return (
      <span className="gdf">
        <h4>Degradation versus Deforestation</h4>
        <p>Deforestation is the conversion of forests to other land uses – globally, agriculture is the single leading factor. Most deforestation happens in tropical rainforests, as can be seen by this "deforestation fronts" data layer. However, the degradation of forests also poses a threat to forests – this is when the structure of a forest is disturbed and diminished through the removal of specific plant or tree species to the extent it can no longer provide its full range of ecological services. In temperate and Boreal forests, industry logging is a primary driver of forest degradation.</p>

        <div className="row">
          <div className="six columns">
            <h5>Deforestation</h5>
            <img alt="deforestation" src="./assets/images/deforestation.jpg" />
          </div>
          <div className="six columns">
            <h5>Degradation</h5>
            <img alt="degradation" src="./assets/images/degradation.jpg" />
          </div>
        </div>
      </span>
    );
  }
}

export default GlobalDeforestationFrontsContent;


// WEBPACK FOOTER //
// ./src/components/Lightbox/GlobalDeforestationFrontsContent.jsx